"use client";

import type { ReactNode } from "react";

import { cn } from "@/shared/lib/utils";

export function appendToSearchQuery(current: string, token: string): string {
  const t = token.trim();
  if (!t) return current.trim();
  const c = current.trim();
  if (!c) return t;
  const parts = c.toLowerCase().split(/\s+/);
  if (parts.includes(t.toLowerCase())) return c;
  return `${c} ${t}`;
}

interface ScrollableTagStripProps {
  children: ReactNode;
  className?: string;
  ariaLabel?: string;
}

export function ScrollableTagStrip({
  children,
  className,
  ariaLabel,
}: ScrollableTagStripProps) {
  return (
    <div
      role="group"
      aria-label={ariaLabel}
      className={cn(
        "flex min-h-9 flex-nowrap items-center gap-2 overflow-x-auto overscroll-x-contain py-0.5 touch-pan-x",
        "[scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden",
        className,
      )}
    >
      {children}
    </div>
  );
}
